export default function accordion() {}
